import { picturePLaceholder } from "assets/icons";
import { Button, LoadingButton } from "components/form";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { uploadFileApi } from "services/media";
import { capitalizeFirstLetter } from "utils/commonHelper";
import { imageFileHandler, showImageHolder } from "utils/mediaHelper";

const UploadImage = ({
  type = "question",
  data,
  handleClose,
  indexValue,
  setSurveyQuestionArray,
  selectedBlock,
  innerIndex = null,
}) => {
  // Set all value
  const [selectedImage, setSelectedImage] = useState("");
  const [isImageUpload, setIsImageUpload] = useState(false);

  const { t } = useTranslation();

  //   handle function

  //   close image handler
  const closeImageQuestionImageHandler = () => {
    setSelectedImage("");
    handleClose();
  };

  // File selection handler
  const onChangeHandler = (e) => {
    e.preventDefault();
    imageFileHandler(e, setSelectedImage);
  };

  // Upload Question Image
  const UploadQuestionImageHandler = async () => {
    try {
      setIsImageUpload(true);
      const responseData = await uploadFileApi(selectedImage);
      const {
        data: { imageUrl = "" },
        status: requstStatus,
      } = responseData;
      if (requstStatus === 200) {
        setSurveyQuestionArray((prevArray) => {
          const updatedArray = { ...prevArray };
          // Update the specific block and index based on type
          if (type === "question") {
            updatedArray[selectedBlock][indexValue]["questionImage"] =
              imageUrl || "";
          }

          if (type === "answer") {
            updatedArray[selectedBlock][indexValue]["option"][
              innerIndex
            ].optionImage = imageUrl || "";
          }
          return updatedArray;
        });
        closeImageQuestionImageHandler();
      }
    } catch (e) {
      console.log("Error:", e.message);
    } finally {
      setIsImageUpload(false);
    }
  };

  return (
    <div className="upload_image_modal">
      <h3>
        {t(
          `CUSTOMIZATION_QUESTION.Upload_${capitalizeFirstLetter(type)}_Image`
        )}
      </h3>

      <div className="picture_question">
        <label className="upload_picture" htmlFor="upload_question_file">
          <input
            type="file"
            id="upload_question_file"
            className="inputHide"
            accept="image/*"
            onChange={onChangeHandler}
          />

          {!selectedImage ? (
            <div className="upload_content">
              <img src={picturePLaceholder} alt="survey question file" />
              <p>{t(`CUSTOMIZATION_QUESTION.${type}_imageHere`)}</p>
            </div>
          ) : (
            <div className="uploaded_image_preview">
              <img
                src={showImageHolder(selectedImage)}
                alt="survey question file"
              />
            </div>
          )}
        </label>
      </div>
      <div className="button_wrap button_center">
        <LoadingButton
          className={"light"}
          loading={isImageUpload}
          onClick={UploadQuestionImageHandler}
        >
          {t(`COMMON.yes`)}
        </LoadingButton>
        <Button onClick={closeImageQuestionImageHandler}>
          {t(`COMMON.no`)}
        </Button>
      </div>
    </div>
  );
};

export default UploadImage;
